class HeaderActions extends HTMLElement {
  connectedCallback() {
    // Custom element for header actions
    // Just ensures shopify-account component is properly registered
  }
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}
